import React from "react";
import { renderToString } from "react-dom/server";
import { IntlShape, defineMessages, injectIntl } from "react-intl";
import { Helmet } from "react-helmet";
import { getAvailableLogoLocale } from "../parameters";
import { TApp } from "../types";
import { getAppPrefix } from "../app";

const messages = defineMessages({
    description: {
        id: "seo.description",
    },
});

const defaultImage = (lang: string, app: TApp | undefined) =>
    `https://musicators.com/images${getAppPrefix(app)}/og-image-${getAvailableLogoLocale(lang, app)}.jpg`;

interface IProps {
    intl: IntlShape | null;
    title: string;
    description?: string;
    ogTitle?: string;
    ogDescription?: string;
    type?: string;
    image?: string;
    noindex?: boolean;
    nofollow?: boolean;
    lang?: string;
    allMessage?: { [key: string]: string },
    app?: TApp;
}

const Seo = ({
    intl,
    title,
    description,
    ogTitle,
    ogDescription,
    type,
    image,
    noindex,
    nofollow,
    lang = "en",
    allMessage,
    app,
}: IProps) => {
    const formatMessage = intl
        ? intl.formatMessage
        : ({ id }: { id: string }) => {
            return allMessage[id];
        };
    return (
        <Helmet
            title={title}
            meta={[
                {
                    property: "og:title",
                    content: ogTitle || title,
                },
                {
                    name: "description",
                    content: description || formatMessage(messages.description),
                },
                {
                    property: "og:description",
                    content: ogDescription || description || formatMessage(messages.description),
                },
                {
                    property: "og:type",
                    content: type || "website",
                },
                {
                    property: "og:image",
                    content: image || defaultImage(intl ? intl.locale : lang, app),
                },
                {
                    property: "robots",
                    content: (noindex ? "noindex" : "index") + ", " + (nofollow ? "nofollow" : "follow"),
                },
            ]}
        />
    );
};

export const SeoRenderer = (props: Omit<IProps, "intl">) => renderToString(<Seo {...props} intl={null} />);

export default injectIntl(Seo);
